@if (showCredentialTypes$ | async) {
  <bit-toggle-group
    fullWidth
    class="tw-mb-4"
    [selected]="credentialType$ | async"
    (selectedChange)="onCredentialTypeChanged($event)"
    [label]="'type' | i18n"
  >
    @for (option of passwordOptions$ | async; track option) {
      <bit-toggle [value]="option.value">
        {{ option.label }}
      </bit-toggle>
    }
  </bit-toggle-group>
}
<bit-card class="tw-flex tw-justify-between tw-mb-4">
  <div class="tw-grow tw-flex tw-flex-col tw-justify-center tw-min-w-0">
    <bit-color-password class="tw-font-mono" [password]="value$ | async"></bit-color-password>
    <div class="tw-mt-2 tw-flex tw-items-center tw-gap-3 tw-text-sm tw-text-muted">
      @if (strengthBadge$ | async; as badge) {
        <span data-testid="password-strength-word" class="tw-font-medium">
          {{ badge.label }}
        </span>
      }
      @if (!isPinMode && (algorithm$ | async)?.id === Algorithm.passphrase) {
        <span>{{ "length" | i18n }}: {{ valueLength$ | async }}</span>
      }
    </div>
  </div>
  <div class="tw-flex tw-items-center tw-space-x-1">
    <button
      type="button"
      bitIconButton="bwi-generate"
      buttonType="primaryGhost"
      (click)="generate(USER_REQUEST)"
      [label]="credentialTypeGenerateLabel$ | async"
      [disabled]="!isPinMode && !(algorithm$ | async)"
    >
      {{ credentialTypeGenerateLabel$ | async }}
    </button>
    <button
      type="button"
      bitIconButton="bwi-clone"
      buttonType="primaryGhost"
      showToast
      [label]="credentialTypeCopyLabel$ | async"
      [appCopyClick]="value$ | async"
      [valueLabel]="credentialTypeLabel$ | async"
      [disabled]="!isPinMode && !(algorithm$ | async)"
    ></button>
  </div>
</bit-card>
@if (isPinMode) {
  <bit-section [disableMargin]="disableMargin" class="tw-mt-6">
    <bit-section-header>
      <h2 bitTypography="h6">{{ "options" | i18n }}</h2>
    </bit-section-header>
    <bit-card>
      <bit-form-field disableMargin>
        <bit-label>{{ "length" | i18n }} ({{ pinMin }}–{{ pinMax }})</bit-label>
        <input
          bitInput
          type="number"
          [min]="pinMin"
          [max]="pinMax"
          [ngModel]="pinLength"
          (ngModelChange)="onPinLengthChange($event)"
          data-testid="pin-length-input"
        />
      </bit-form-field>
    </bit-card>
  </bit-section>
} @else if ((algorithm$ | async)?.id === Algorithm.password) {
  <tools-password-settings
    class="tw-mt-6"
    [account]="account$ | async"
    [disableMargin]="disableMargin"
    (onUpdated)="generate('password settings')"
  />
} @else if ((algorithm$ | async)?.id === Algorithm.passphrase) {
  <tools-passphrase-settings
    class="tw-mt-6"
    [account]="account$ | async"
    (onUpdated)="generate('passphrase settings')"
    [disableMargin]="disableMargin"
  />
}
